import { capitalize as lodashCapitalize } from 'lodash';

export const capitalize = <S extends string>(str: S) =>
  lodashCapitalize(str) as Capitalize<S>;
